const BatchManagementPage = () => (
  <div className="p-8 bg-white rounded-lg shadow-xl">
    <h2 className="text-3xl font-bold text-gray-800 mb-6">Batch Management</h2>
    <div className="mb-6">
      <h3 className="text-2xl font-semibold text-gray-700 mb-4">Create New Batch</h3>
      <form className="space-y-2 max-w-xl">
        <div>
          <label htmlFor="batchName" className="block text-gray-700 text-sm font-semibold mb-2">Batch Name:</label>
          <input type="text" id="batchName" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500" />
        </div>
        <div>
          <label htmlFor="course" className="block text-gray-700 text-sm font-semibold mb-2">Course:</label>
          <select id="course" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500">
            <option>Hatha Yoga</option>
            <option>Vinyasa Flow</option>
            <option>Restorative Yoga</option>
          </select>
        </div>
        <div>
          <label htmlFor="trainer" className="block text-gray-700 text-sm font-semibold mb-2">Trainer:</label>
          <select id="trainer" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500">
            <option>Sarah Chen</option>
            <option>David Lee</option>
            <option>Emily White</option>
          </select>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label htmlFor="startTime" className="block text-gray-700 text-sm font-semibold mb-2">Start Time:</label>
            <input type="time" id="startTime" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500" />
          </div>
          <div>
            <label htmlFor="endTime" className="block text-gray-700 text-sm font-semibold mb-2">End Time:</label>
            <input type="time" id="endTime" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500" />
          </div>
        </div>
        <button type="submit" className="bg-green-600 text-white py-2 px-6 rounded-md hover:bg-green-700 transition-colors duration-300 font-semibold">Create Batch</button>
      </form>
    </div>
    <div className="mt-8">
      <h3 className="text-2xl font-semibold text-gray-700 mb-4">Active Batches</h3>
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-md">
          <thead>
            <tr className="bg-gray-100 border-b border-gray-200">
              <th className="py-3 px-6 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">Batch Name</th>
              <th className="py-3 px-6 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">Course</th>
              <th className="py-3 px-6 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">Trainer</th>
              <th className="py-3 px-6 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">Time</th>
              <th className="py-3 px-6 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            <tr>
              <td className="py-4 px-6 whitespace-nowrap">Morning Flow</td>
              <td className="py-4 px-6 whitespace-nowrap">Vinyasa Flow</td>
              <td className="py-4 px-6 whitespace-nowrap">David Lee</td>
              <td className="py-4 px-6 whitespace-nowrap">9:00 AM - 10:00 AM</td>
              <td className="py-4 px-6 whitespace-nowrap">
                <button className="text-indigo-600 hover:text-indigo-900 mr-3">Edit</button>
                <button className="text-red-600 hover:text-red-900">Delete</button>
              </td>
            </tr>
            <tr>
              <td className="py-4 px-6 whitespace-nowrap">Evening Serenity</td>
              <td className="py-4 px-6 whitespace-nowrap">Restorative Yoga</td>
              <td className="py-4 px-6 whitespace-nowrap">Sarah Chen</td>
              <td className="py-4 px-6 whitespace-nowrap">6:00 PM - 7:00 PM</td>
              <td className="py-4 px-6 whitespace-nowrap">
                <button className="text-indigo-600 hover:text-indigo-900 mr-3">Edit</button>
                <button className="text-red-600 hover:text-red-900">Delete</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
);


export default BatchManagementPage;
